import EmojiResource from '@atlaskit/emoji/emoji-resource';

import { getEmojiProviderConfig } from './get-emoji-provider-config';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getEmojiProviderConfig } from './get-emoji-provider-config';

// In-memory store of emoji resources previous constructed.
// Key: cloudId (undefined is the base resource)
// Value: EmojiResource

const emojiCloudIdToResourceMap: Map<string | undefined, EmojiResource> = new Map<
	string,
	EmojiResource
>();

export const getEmojiResource = async (
	cloudId?: string,
	baseUrl?: string,
): Promise<EmojiResource> => {
	const existingResource = emojiCloudIdToResourceMap.get(cloudId);
	if (existingResource) {
		return existingResource;
	}

	const newConfig = getEmojiProviderConfig(cloudId, baseUrl);
	const resource = new EmojiResource(newConfig);

	emojiCloudIdToResourceMap.set(cloudId, resource);

	return resource;
};
